import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AVAILABLE_SPORT_IMAGES } from 'utils/constants/sportsbook/images';
import SpringConfigs, {
  srcEnvVariable
} from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { getSportsConfigsData } from 'store/selectors/app-data';

export const useSportImage = (sportAlias?: string): string => {
  const sportsConfigsData = useSelector(getSportsConfigsData);

  return useMemo(() => {
    const sportAliasLowerCased = sportAlias?.toLowerCase();
    const deviceType = isMobile() ? 'mobile' : 'desktop';
    const imageName = AVAILABLE_SPORT_IMAGES.includes(
      sportAliasLowerCased || ''
    )
      ? sportAliasLowerCased
      : 'default';

    const sportConfigImg =
      sportAliasLowerCased &&
      sportsConfigsData[sportAliasLowerCased.concat('Image')];

    if (SpringConfigs.USER_FILES_URL && sportAlias && sportConfigImg) {
      return `${SpringConfigs.USER_FILES_URL}/media/${sportConfigImg}`;
    }

    return `${process.env[srcEnvVariable]}/images/sports-${deviceType}/${imageName}.webp`;
  }, [sportAlias]);
};
